import http from 'plugins/axios'

export default {
  // getAuditList(data) {
  //   return http.get({
  //     url: '/la/admin/workorder/deposite_audit_List',
  //     data
  //   });
  // },

  gethashList(data) {
    return http.get({
      // url: '/la/admin/workorder/deposite_tranfer_query',
      url: '/la/admin/workorder/search_deposit',
      data,
    })
  },
  getAllCoins() {
    return http.get({
      url: '/la/admin/coin/coin-list',
    })
  },
  mock_deposit(data) {
    return http.post({
      url: '/la/admin/workorder/mock_deposit',
      data,
      dataType: 'form',
    })
  },
  getTestDepositChains(data) {
    return http.get({
      url: '/la/admin/workorder/test_deposit/chains',
      data,
    })
  },
  test_deposit(data) {
    return http.post({
      url: '/la/admin/workorder/test_deposit',
      data,
      dataType: 'form',
    })
  },
  getTotalInfo(data) {
    return http.get({
      // url: '/la/admin/workorder/deposite_tranfer_query',
      url: '/la/admin/workorder/search_deposit_total',
      data,
    })
  },


  getSearchDepositExport(data) {
    return http.get({
      url: `/la/admin/workorder/getSearchDepositExport`,
      data,
      responseType: 'blob'
    })
  },
}
